import React, { useContext, useEffect, useMemo, useState } from "react";
import Style from "./index.module.scss";
import useDeviceType from "../../../../../Utils/useDeviceType";
import useRequestFn from "../../../../../Utils/useRequestFn";
import {
    FILETYPE_LIST,
    GetGroupDetailProps,
    queryGroupActivityDetail,
    saveGroupAnswer,
    submitGroupHomework,
    TaskFileEntityList,
    TeamCanType
} from "../../../../../API/teams";
import { CourseContext } from "../../../Store";
import useRequest, { errorMessage } from "../../../../../Utils/useRequest";
import FileItem from "./Components/FileItem";
import { Button, Col, Input, message, Modal, Row, Spin } from "antd";
import PreviewSourceModal from "../../../../../components/PreviewSourceModal";
import useModalHandler from "../../../../../Utils/v2/useModalHandler";
import TeamHeader from "../../../components/TeamLayout/components/TeamHeader";
import ChainUpload from "../../../../../components/ChainUpload";
import { ChainUploadFileProps } from "../../../../../components/ChainUpload/servers";
import { humanFileSize, isTrue } from "../../../../../Utils/filter";
import Config from "../../../../../config";
import { ResultMessage } from "../../../../../components/ResultMessage";
import { useHistory, useParams } from "react-router-dom";
import lodash from "lodash-es";

const Index = () => {
    const { taskId, activityId, groupLeaderNo, groupId, groupType } =
        useParams<GetGroupDetailProps>();
    const { isPC, isMobile } = useDeviceType();
    const { basename } = useContext(CourseContext);

    const [submitAction, { loading: submitLoading }] =
        useRequestFn(submitGroupHomework);
    const [saveAction, { loading: editLoading }] =
        useRequestFn(saveGroupAnswer);

    const [data, { loading }, reloadData] = useRequest(
        async () =>
            queryGroupActivityDetail({
                activityId,
                groupId,
                groupLeaderNo,
                groupType,
                taskId
            }),
        {},
        [taskId, groupId]
    );

    useEffect(() => {
        if (data?.homeworkInfo) {
            setTaskAnswer(data.homeworkInfo.taskAnswer);
        }
    }, [data]);

    //预览

    const prevModal = useModalHandler(PreviewSourceModal);
    function onPrev(id: number | string, list: TaskFileEntityList[]) {
        prevModal.setPayload(id);
        prevModal.setList(list);
        prevModal.open();
    }

    async function onUploadSuccess(files: ChainUploadFileProps[]) {
        const list = files
            .filter(item => item.status === "done")
            .map((item, index) => {
                const type = item.file.name.split(".").pop();
                return {
                    fileName: item.file.name,
                    fileSize: humanFileSize(item.file.size),
                    fileUrl: `${Config.QiNiuDownloadUrl}/${item.response?.key}`,
                    fileType: type?.toLowerCase() || "",
                    id: -(
                        (data?.homeworkInfo?.homeworkFileList?.length || 0) +
                        index +
                        1
                    ),
                    uuid: "",
                    delStatus: 0,
                    uploadType: "1"
                };
            });

        let saveObj: TaskFileEntityList[] = [];
        if (data?.homeworkInfo?.homeworkFileList) {
            saveObj.push(...data.homeworkInfo.homeworkFileList);
        }
        saveObj.push(...list);

        await onSave(saveObj);
    }

    async function onSave(homeworkFileList?: TaskFileEntityList[]) {
        try {
            const loginStuNo = localStorage.getItem("STUDENTNO");
            await saveAction({
                activityId,
                answerMemberNo: loginStuNo!,
                groupId,
                homeworkFileList:
                    homeworkFileList ||
                    data?.homeworkInfo?.homeworkFileList ||
                    [],
                taskAnswer,
                taskId
            });
            await reloadData();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function onCancel() {}

    async function deleteList(file: TaskFileEntityList) {
        const _homeworkFileList = lodash.cloneDeep(
            data?.homeworkInfo?.homeworkFileList
        );
        const current = lodash.find(_homeworkFileList, { uuid: file.uuid });
        const currentIndex = lodash.findIndex(_homeworkFileList, {
            uuid: file.uuid
        });
        if (current) {
            current.delStatus = 1;
        }
        if (Array.isArray(_homeworkFileList)) {
            // @ts-ignore
            _homeworkFileList[currentIndex] = current;
        }
        await onSave(_homeworkFileList);
    }

    function submitPrev() {
        Modal.confirm({
            width: 1000,
            centered: true,
            maskClosable: false,
            icon: "",
            okButtonProps: { type: "primary" },
            cancelButtonProps: { type: "default" },
            okText: "提交",
            cancelText: "取消",
            onOk() {
                submit();
            },
            content: (
                <div className={Style.prev}>
                    <h1 className={Style.prevTitle}>{taskAnswer}</h1>
                    <Row className={Style.fileRow} gutter={30}>
                        {data?.homeworkInfo?.homeworkFileList.map(
                            (item, index) => (
                                <Col
                                    span={8}
                                    key={item.id}
                                    className={Style.upItem}>
                                    <FileItem data={item} showTools={false} />
                                </Col>
                            )
                        )}
                    </Row>
                </div>
            )
        });
    }

    const [taskAnswer, setTaskAnswer] = useState<string>("");

    const history = useHistory();

    async function submit() {
        if (data) {
            try {
                await submitAction({ activityId, groupId, taskId });
                message.success("提交成功");
                history.push(`${basename}/teams`);
            } catch (e) {
                ResultMessage.error(errorMessage(e, "发生错误，请联系管理员"));
            }
        }
    }

    const headerInfo = useMemo(() => {
        return `任务名称:${data?.taskInfo?.taskName} 截止时间:${data?.activityInfo.deadlineStr} 分值:${data?.taskInfo?.score}分`;
    }, [data]);

    return (
        <>
            <div className={Style.root}>
                {/*{taskAnswer !== data?.taskAnswer && (*/}
                {/*    <div className={Style.tips}>*/}
                {/*        过命的好兄弟，你上次改完提交按钮点了吗？现在可是草稿内容*/}
                {/*    </div>*/}
                {/*)}*/}
                {isPC && (
                    <TeamHeader
                        title={data?.activityInfo.activityName}
                        info={headerInfo}>
                        <>
                            <Button
                                style={{ borderRadius: 2 }}
                                onClick={() =>
                                    history.push(`${basename}/teams/my`)
                                }
                                icon="team"
                                type="link">
                                我的小组
                            </Button>
                            {isTrue(data?.canEdit) && isPC && (
                                <div className={Style.footer}>
                                    <Button
                                        style={{ borderRadius: 2 }}
                                        type="primary"
                                        ghost
                                        onClick={submitPrev}>
                                        预览
                                    </Button>
                                    <Button
                                        type="primary"
                                        style={{ borderRadius: 2 }}
                                        onClick={submit}>
                                        提交
                                    </Button>
                                </div>
                            )}
                        </>
                    </TeamHeader>
                )}
                <div className={Style.topPadding} />
                {/*{isPC && (*/}
                {/*    <NavBar>*/}
                {/*        <a*/}
                {/*            href="#"*/}
                {/*            className={classNames(*/}
                {/*                Style.link,*/}
                {/*                Style.links,*/}
                {/*                Style.current*/}
                {/*            )}>*/}
                {/*            回答*/}
                {/*        </a>*/}
                {/*    </NavBar>*/}
                {/*)}*/}
                <Spin spinning={loading || submitLoading || editLoading}>
                    <div className={Style.main}>
                        {/*<div className={Style.title}>*/}
                        {/*    <div className={Style.scope}>{data?.score}分</div>*/}
                        {/*    <span className={Style.taskName}>*/}
                        {/*        {data?.taskName}*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        {data?.statusInfo?.hasCorrected === TeamCanType.yes && (
                            <div className={Style.remarkRow}>
                                <table className={Style.remarkTable}>
                                    <tr className={Style.remarkTr}>
                                        <td className={Style.remarkTitle}>
                                            小组得分
                                        </td>
                                        <td className={Style.remarkScope}>
                                            {data?.memberGradeInfo?.groupScore}
                                        </td>
                                        <td className={Style.remarkTitle}>
                                            个人得分
                                        </td>
                                        <td className={Style.remarkScope}>
                                            {data?.memberGradeInfo?.memberScore}
                                        </td>
                                    </tr>
                                    <tr className={Style.remarkTr}>
                                        <td className={Style.remarkTitle}>
                                            教师评语
                                        </td>
                                        <td
                                            className={Style.remarkText}
                                            colSpan={3}>
                                            {data?.homeworkInfo?.remark}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        )}
                        <div className={Style.body}>
                            <p className={Style.text}>
                                {data?.taskInfo?.taskQuestion}
                            </p>
                            <Row className={Style.fileRow} gutter={30}>
                                {data?.taskInfo?.taskFileEntityList &&
                                    data?.taskInfo?.taskFileEntityList.map(
                                        item => (
                                            <Col
                                                span={isPC ? 8 : 24}
                                                key={item.id}>
                                                <FileItem
                                                    onPrev={() =>
                                                        onPrev(
                                                            item.id,
                                                            data?.taskInfo
                                                                ?.taskFileEntityList
                                                        )
                                                    }
                                                    data={item}
                                                />
                                            </Col>
                                        )
                                    )}
                            </Row>
                            <div className={Style.content}>
                                <div className={Style.tag}>小组回答</div>
                                {isPC && (
                                    <Input.TextArea
                                        onBlur={() => onSave()}
                                        disabled={!isTrue(data?.canEdit)}
                                        rows={10}
                                        value={taskAnswer}
                                        onChange={e =>
                                            setTaskAnswer(e.target.value)
                                        }
                                        placeholder="请输入"
                                    />
                                )}
                                {isMobile && (
                                    <div className={Style.taskBg}>
                                        <div className={Style.text}>
                                            {taskAnswer}
                                        </div>
                                    </div>
                                )}

                                <div className={Style.nums}>
                                    <span>
                                        附件数 (
                                        {
                                            data?.homeworkInfo?.homeworkFileList
                                                .length
                                        }
                                        )
                                    </span>
                                    {isTrue(data?.canEdit) && isPC && (
                                        <ChainUpload
                                            onUploadSuccess={onUploadSuccess}
                                            onCancel={onCancel}
                                            tokenUrl="/student/getUpToken"
                                            uploadUrl="https://up-z1.qiniup.com"
                                            TypeList={FILETYPE_LIST}
                                        />
                                    )}
                                </div>

                                <Row
                                    className={Style.fileRow}
                                    gutter={isPC ? 30 : 15}>
                                    {data?.homeworkInfo?.homeworkFileList.map(
                                        (item, index) => (
                                            <Col
                                                span={isPC ? 8 : 24}
                                                key={item.id}
                                                className={Style.upItem}>
                                                <FileItem
                                                    data={item}
                                                    onPrev={() =>
                                                        onPrev(
                                                            item.id,
                                                            data?.homeworkInfo
                                                                ?.homeworkFileList
                                                        )
                                                    }>
                                                    <>
                                                        {isTrue(
                                                            data?.canEdit
                                                        ) &&
                                                            isPC && (
                                                                <img
                                                                    src={require("./img/delete.png")}
                                                                    className={
                                                                        Style.delete
                                                                    }
                                                                    onClick={() =>
                                                                        deleteList(
                                                                            item
                                                                        )
                                                                    }
                                                                />
                                                            )}
                                                    </>
                                                </FileItem>
                                            </Col>
                                        )
                                    )}
                                </Row>
                            </div>
                        </div>
                    </div>
                </Spin>

                {prevModal.render(
                    <PreviewSourceModal FILETYPE_LIST={FILETYPE_LIST} />
                )}
            </div>
        </>
    );
};

export default Index;
